import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const lang = localStorage.getItem('lang') || 'en';

//create sub category
export const createSubCategory = async (categoryData) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/sub-categories/create`, categoryData);
    return response.data;
  } catch (error) {
    console.error("Fetch Categories API Error:", error);
    throw error;
  }
};

// get sub category
export const getAllSubCategories = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/sub-categories/list`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Accept-Language': lang
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch Subcategories API Error:", error);
    throw error;
  }
};

export const updateSubCategory = async (id, payload) => {
  const response = await api.put(`${API_BASE_URL}api/sub-categories/update/${id}`, payload);
  return response.data;
};

export const deleteSubCategory = async (id) => {
  return await api.delete(`${API_BASE_URL}api/sub-categories/delete/${id}`);
};